<template>
  <div
    :class="[
      'v-searchable-select',
      'v-searchable-select-shallow',
      small && 'v-searchable-select--small',
      gray && 'v-searchable-select--gray',
      search && 'v-searchable-select--search',
      disabled && 'v-searchable-select-shallow--disabled'
    ]"
    v-on="$listeners">
    <div v-if="!async" :class="['multiselect__caret', { 'mr-5': !!tooltip }]">
      <v-icon name="caret" width="12" />
    </div>
    <div v-if="search" class="multiselect__search-icon">
      <v-icon name="search" width="22" />
    </div>
    <div :class="[ 'multiselect__tags', { 'multiselect__tags--error': isError }]">
      <span v-if="!multiple" class="multiselect__placeholder" :class="{ 'multiselect__placeholder--value': getInputValue }">{{ getLabel() }}</span>
      <span v-else class="multiselect__placeholder" :class="{ 'multiselect__placeholder--value': getInputValue }">
        <span class="multiselect__tag" v-for="tag in getLabel()" :key="tag.name">{{ tag.name }} <span @click.stop.prevent="removeTag(tag.name)" class="multiselect__tag-icon"></span></span>
      </span>
      <div :class="['v-searchable-select-shallow__label',
        {
          'v-searchable-select-shallow__label--active': getInputValue || address,
          'v-searchable-select-shallow__label--error': isError,
          'v-searchable-select-shallow__label__search': search 
        }]"
      >
        <span :class="
          ['v-searchable-select-shallow__label__text',
            { 
              'v-searchable-select-shallow__label__text--active': getInputValue ||address
            }
          ]
        ">
          {{ placeholder }}
        </span>
      </div>
    </div>
    <span v-if="address && !getInputValue" :class="['v-searchable-select-shallow__label__address']"> {{ address }}</span>
    <span class="v-searchable-select-shallow__error" v-if="isError">{{ error }}</span>
    <input
      type="text"
      class="v-searchable-select-shallow__input"
      :name="name" 
      :value="getInputValue"
      :required="required"
      @invalid="handleInvalid($event)"
    />
  </div>
</template>

<script>
import vIcon from "../v-icon/v-icon.vue";
export default {
  components: { vIcon },
  props: {
    placeholder: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    value: {
      type: [Array, Object, String],
      default: null
    },
    label: {
      type: String,
      default: null
    },
    async: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    gray: {
      type: Boolean,
      default: false
    },
    search: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: null
    },
    showError: {
      type: Boolean,
      default: null
    },
    tooltip: {
      type: String,
      default: null
    },
    address: {
      type: String,
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isError: false
    };
  },
  watch: {
    getInputValue() {
      if (this.isError && this.getInputValue) {
        this.isError = false;
      }
    }
  },
  computed: {
    getInputValue() {
      if (this.value) {
        return this.value["value"] || this.value;
      } else {
        return null;
      }
    }
  },
  methods: {
    removeTag(tag) {
      this.value.splice(this.value.findIndex(el => el.name === tag), 1);
    },
    handleInvalid(event) {
      if (event && event.type === "invalid") {
        this.isError = true;
      } else {
        this.isError = false;
      }
    },
    getLabel() {
      if (this.value) {
        return this.value[this.label] || this.value;
      }
      return null;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../sass/component.scss";

.v-searchable-select-shallow {
  position: relative;
  cursor: pointer;
  width: 100%;

  &__input {
    position: absolute;
    opacity: 0;
  }

  &__error {
    color: theme-color("danger");
    margin-top: 5px;
    font-size: 0.75rem;
  }

  &--disabled {
    pointer-events: none;
    opacity: 0.5;
  }

  .multiselect__placeholder {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__label {
    display: inline-block;
    position: absolute;
    top: 13px;
    left: 10px;
    right: auto;
    bottom: auto;
    max-width: 100%;
    color: theme-color("placeholder");
    background: transparent;
    padding: 0 5px;
    transform-origin: left top;
    transition: all 200ms ease-out;
    cursor: text;
    pointer-events: none;
    white-space: nowrap;

    &__search {
      top: 16px;
      left: $spacer * 3;
    }

    &__address {
      display: inline-block;
      position: absolute;
      top: 13px;
      left: 10px;
      right: auto;
      bottom: auto;
      max-width: 100%;
      color: theme-color("black");
      background: transparent;
      padding: 0 5px;
      transform-origin: left top;
      transition: all 200ms ease-out;
      cursor: text;
      pointer-events: none;
      white-space: nowrap;
    }

    &__text {
      &--active {
        position: relative;
        top: -12px;
      }
    }

    &--active {
      background-color: theme-color("white");
      top: 0px;
      z-index: 100;
      font-size: 0.8125rem;
      height: 5px;
    }

    &--error {
      color: theme-color("danger");
    }

    .v-searchable-select--gray & {
      background-color: inherit;
    }
  }

  &__label {
    display: inline-block;
    position: absolute;
    z-index: 100;
    left: 10px;
    right: auto;
    bottom: auto;
    max-width: 100%;
    color: theme-color("placeholder");
    background: transparent;
    padding: 0 5px;
    transform-origin: left top;
    transition: all 200ms ease-out;
    cursor: text;
    pointer-events: none;
    white-space: nowrap;
    z-index: 100;

    &__search {
      top: 16px;
      left: $spacer * 3;
    }

    &__address {
      display: inline-block;
      position: absolute;
      top: 13px;
      left: 10px;
      right: auto;
      bottom: auto;
      max-width: 100%;
      color: theme-color("black");
      background: transparent;
      padding: 0 5px;
      transform-origin: left top;
      transition: all 200ms ease-out;
      cursor: text;
      pointer-events: none;
      white-space: nowrap;
    }

    &__text {
      &--active {
        position: relative;
        top: -12px;
      }
    }

    &--active {
      background-color: theme-color("white");
      top: 0px;
      z-index: 100;
      font-size: 0.8125rem;
      height: 5px;
    }

    &--error {
      color: theme-color("danger");
    }

    .v-searchable-select--gray & {
      background-color: inherit;
    }
  }
}
</style>
